import { Box, Select, Spinner } from '@chakra-ui/react';
import { translate } from '../../../i18n';
import { OrganizationLocationDto } from '../../../models/location/dto/location.dto';
import { useSingleClubAutoSelect } from '../hooks/useSingleClubAutoSelect';
type Props = { selectedLocation?: OrganizationLocationDto; setSelectedLocation: (loc: OrganizationLocationDto) => void };
export default function LocationPicker({ selectedLocation, setSelectedLocation }: Props) {
    const { locations, isLoading, isSingleClub } = useSingleClubAutoSelect({
        selectedLocation,
        onSelect: setSelectedLocation,
    });

    // `isLoading` here is `isInitialLoading` (see `useIsSingleClub`), NOT the
    // raw React Query flag. It matters on this component more than on any
    // other in the dashboard: `LocationPicker` is mounted by `SearchBar` in
    // the navbar of every admin page, and the locations read is
    // `enabled: Boolean(organizationId)`. With the raw flag, an operator with
    // no organization selected would get this spinner in the navbar of every
    // page, forever — a `placeholderData: []` on the hook had been hiding that
    // by keeping `isLoading` permanently false, so this branch was dead code
    // until run 107 removed the placeholder.
    if (isLoading) {
        return <Spinner />;
    }

    // MYS-66: with a single club there is nothing to choose — it has been
    // auto-selected above, so hide the selector entirely.
    if (isSingleClub) {
        return null;
    }

    return (
        <Box>
            <Select
                borderRadius={50}
                placeholder={translate('organization.select_location')}
                value={selectedLocation?.id}
                onChange={(e) => {
                    setSelectedLocation((locations || []).find(o => o.id === e.target.value))
                }}
            >
                {(locations || []).map((location) => (
                    <option key={location.id} value={location.id}>
                        {location.name}
                    </option>
                ))}
            </Select>
        </Box>
    );
}
